export default __webpack_public_path__ + "static/media/Aegis of the Warlord.59d28ba9.jpg";